// extracted by mini-css-extract-plugin
module.exports = {"errorPageContainer":"Error_errorPageContainer__2C_NK","paymentCancel":"Error_paymentCancel__1A_8f","oops":"Error_oops__3K-Au"};